import Vue from 'vue'
export default {
  template: `<div class="v__modal" @click="close" v-if="visible">
  <div class="v__img__box">
  <img :src="src" class="v__img" ></img>
  </div>
  </div>`,
  $view: null,
  async show(src) {
    if (!this.$view) {
      const View = Vue.extend({
        template: this.template,
        data() {
          return { src, visible: true }
        },
        methods: {
          close() {
            this.visible = false
          }
        }
      })
      this.$view = new View().$mount()
      document.body.appendChild(this.$view.$el)
    } else {
      this.$view.src = src
      this.$view.visible = true
    }
  }
}
